<template>
    <div class="app-container" style="background: #f4f5f7;">
        <BjSteps active="3" :title="$t('route.BusinessProfitCalculator')" :defaultOptions="[$t('toolsProfit.CustomerDetails'),$t('toolsProfit.ChargeItems'),$t('toolsProfit.calculate')]"></BjSteps>

        <div class="flex flex-spacebetween">
            <div class="profit-left">
                <BjDivider>{{ $t('toolsProfit.CustomerDetails') }}
                    <template slot="right">
                        <el-button type="primary" @click="calculate">{{ $t('toolsProfit.calculate') }}</el-button>
                    </template>
                </BjDivider>
                <el-form ref="form" label-width="140px" :model="form" :rules="rules" class="form" label-position="left">
                    <el-form-item :label="$t('billingPage.CustomerName')" prop="customerName">
                        <BjInput v-model="form.customerName" :maxlength="MAX_LENGTH.NORMAL" :placeholder="$t('inputText')" clearable  style="width:250px"/>
                    </el-form-item>
                    <el-form-item :label="$t('toolsProfit.DataModel')" prop="dataModel">
                        <div style="width:250px">
                            <BjSelectLov v-model="form.dataModel" :option-list="dataModelList" />
                        </div>
                    </el-form-item>
                    <el-form-item :label="$t('AccountManagementAdd.customerInfo.CustomerType')" prop="customerType">
                        <div style="width:250px">
                            <BjInput v-model="customerText" :disabled="true" :placeholder="$t('inputText')">
                                <template slot="append">
                                    <el-button @click="openCustomerType">{{ $t('chooseText') }}</el-button>
                                </template>
                            </BjInput>
                        </div>
                    </el-form-item>
                    <el-form-item :label="$t('toolsProfit.Storage')" prop="storage">
                        <div class="flex-align">
                            <BjInputMoney v-model="form.storage" :maxlength="MAX_LENGTH.NORMAL" :placeholder="$t('inputText')" clearable  style="width:250px"/>
                            <span style="margin-left:8px;">{{selectObj.storageType}}</span>
                        </div>
                    </el-form-item>
                    <el-form-item :label="$t('toolsProfit.PostageMargin')" prop="postageMargin">
                        <div class="flex-align">
                            <el-input
                                v-model="form.postageMargin" :controls="false" :placeholder="$t('inputText')"
                                onkeyup="this.value = this.value.replace(/[^\d.-]/g,'');" style="width:250px;"
                            >
                                <template slot="append">%</template>
                            </el-input>
                        </div>
                    </el-form-item>
                    <el-form-item :label="$t('toolsProfit.WeeklyOrder')" prop="weeklyOrder">
                        <BjInputMoney v-model="form.weeklyOrder" :maxlength="MAX_LENGTH.NORMAL" :placeholder="$t('inputText')" clearable  style="width:250px"/>
                    </el-form-item>
                    <el-form-item :label="$t('toolsProfit.timePeriod')" prop="timePeriodFrom" v-if="form.dataModel == 2">
                        <BjDateRangePicker v-model="dataTime" :picker-options="pickerOptions" :placeholder="$t('toolsProfit.timePeriod')" style="width:250px"/>
                    </el-form-item>
                </el-form>
            </div>
            <div class="profit-right">
                <BjDivider>{{ $t('toolsProfit.ProfitComparison') }}</BjDivider>
                <el-table :data="calculateTable" stripe border>
                    <el-table-column type="index" :label="$t('InternalOrderList.number')" align="center" width="60" />
                    <el-table-column prop="comparisonItem" :label="$t('toolsProfit.ComparisonItem')" align="center" />
                    <el-table-column prop="sampleCompany" :label="$t('toolsProfit.SampleCompany')" align="center" />
                    <el-table-column prop="potentialCustomer" :label="$t('toolsProfit.PotentialCustomer')" align="center" />
                </el-table>
            </div>
        </div>
        <div class="profit-bottom">
            <BjDivider>{{ $t('toolsProfit.ChargeItems')}}
                <template slot="right">
                    <el-button type="primary" :disabled="tableData[0] && !tableData[0].group" @click="downLoad">{{ $t('downloadText') }}</el-button>
                </template>
            </BjDivider>
            <div v-for="(item, index) in tableData" :key="index">
                <el-table :data="item.chargeItems" stripe border>
                    <el-table-column :label="item.group" align="center">
                        <el-table-column prop="id" :label="$t('InternalOrderList.number')" align="center" width="60"/>
                        <el-table-column prop="chargeItem" :label="$t('billingPage.ChargeItem')" align="center" width="445"/>
                        <el-table-column prop="quantity" :label="$t('billingPage.quantity')" align="center"/>
                        <el-table-column prop="standardPrice" :label="$t('billingPage.standardPrice')" align="center" >
                            <template slot-scope="scope">${{ scope.row.standardPrice }}</template>
                        </el-table-column>
                        <el-table-column prop="cost" :label="$t('billingPage.Cost')" align="center" >
                            <template slot-scope="scope">${{ scope.row.cost }}</template>
                        </el-table-column>
                        <el-table-column prop="slendierPrice" :label="`${selectObj.sampleCompany?selectObj.sampleCompany:''} ${$t('goodsSku.detail.Price')}`" align="center" >
                            <template slot-scope="scope">${{ scope.row.slendierPrice }}</template>
                        </el-table-column>
                        <el-table-column prop="quote" :label="$t('toolsProfit.Quote')" align="center" >
                            <template slot-scope="scope">
                                <el-input
                                    v-model="scope.row.quote" class="full-width" :controls="false"
                                    onkeyup="this.value = this.value.replace(/[^\d.-]/g,'');" style="width:100px;"
                                >
                                    <template slot="prepend">$</template>
                                </el-input>
                            </template>
                        </el-table-column>
                    </el-table-column>
                </el-table>
            </div>
        </div>


        <BjDialogList ref="BjDialogListRef" width="80%"
            :serial="false"
            :show-tags="false"
            :config="BjDialogListConfig"
            @confirm="confirm"
        />
    </div>
</template>

<script>
import { billApi } from '@/api';
import { downloadBlob } from '@/utils/index';

export default {
  name: 'profitCalculator',
  data() {
    return {
        form: {
            customerName: '',
            customerType: null,
            storage: null,
            postageMargin: null,
            weeklyOrder: null,
            chargeItems: null,
            dataModel: 1,
            timePeriodFrom: null,
            timePeriodTo: null
        },
        rules: {
            customerName: [{ required: true, message: this.$t('inputText'), trigger: 'change' }],
            customerType: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
            storage: [{ required: true, message: this.$t('inputText'), trigger: 'change' }],
            postageMargin: [{ required: true, message: this.$t('inputText'), trigger: 'change' }],
            weeklyOrder: [{ required: true, message: this.$t('inputText'), trigger: 'change' }],
            dataModel: [{ required: true, message: this.$t('inputText'), trigger: 'change' }],
            timePeriodFrom: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        },
        tableData: [
            {chargeItems: [], group: ''}
        ],
        customerTypeList: [],
        calculateTable: [],
        customerText: '',
        selectObj:{},
        dataModelList: [
            { label: this.$t('toolsProfit.PotentialUserProfitPrediction'), value: 1 },
            { label: this.$t('toolsProfit.ExistingCustomerProfitAdjustment'), value: 2 },
        ],
        dataTime: [],
        pickerOptions: {},
        clientCodeList: [],
        BjDialogListConfig:{
            title: '',
            columns: [
                { prop: 'id', label: this.$t('table.countText'), width: 80 },
                { prop: 'industry', label: this.$t('toolsProfit.industry') },
                { prop: 'productDescription', label: this.$t('billingPage.description') },
                { prop: 'sampleCompany', label: this.$t('toolsProfit.SampleCompany') },
                { prop: 'clientTemplate', label: this.$t('toolsProfit.ClientTemplate') },
                { prop: 'type', label: this.$t('toolsProfit.BorC'), width: 100 },
            ],
            search: [
                { placeholder: this.$t('billingPage.companyName'), key: 'clientCode', component: 'BjSelectLov', optionList:[] }
            ],
            query: null,
            defaultQuery: {dataModel:null},
            actionApi: billApi.getCustomerType,
        },
    }
  },
  watch: {
      dataTime(v) {
         this.form.timePeriodFrom = (v || [])[0];
         this.form.timePeriodTo = (v || [])[1];
      },
  },
  created(){
    this.getClientInfoList();
  },
  methods: {
    confirm(data){
        this.customerText = `${data[0].industry}-${data[0].sampleCompany ? data[0].sampleCompany : ''}`
        this.form.customerType = data[0].clientCode
        this.selectObj = data[0];
        this.changeCustomerType(data[0].clientCode)
        if(this.form.dataModel == 2){
            const startDate = new Date(data[0].startDate);
            const endDate = new Date(data[0].endDate);
            this.pickerOptions = {
                disabledDate(time) {
                    return time.getTime() < startDate.getTime() || time.getTime() > endDate.getTime();
                },
            };
        }
    },
    openCustomerType(){
        this.dataTime = []
        this.form.timePeriodFrom = null;
        this.form.timePeriodTo = null;
        // this.init()
        this.BjDialogListConfig.search[0].optionList = this.clientCodeList
        this.BjDialogListConfig.defaultQuery.dataModel = this.form.dataModel
        this.$refs.BjDialogListRef.show();
    },
    init(){
        billApi.getCustomerType({ dataModel: this.form.dataModel }).then(res=>{
            this.customerTypeList = res.data;
        })
    },
    changeCustomerType(val){
        billApi.getChargeItems({customerType: val, dataModel: this.form.dataModel}).then(res=>{
            this.tableData = res.data
        })
    },
    calculate(){
        this.$refs.form.validate(valid => {
            if (valid) {
                let arr = []
                let bstop = true;
                this.tableData.forEach(item=>{
                    item.chargeItems.forEach(jitem=>{
                        if(!this.isNotEmptyOrZero(jitem.quote)){
                            bstop = false;
                        }
                        arr.push({ billCategoryCode: jitem.billCategoryCode, quote: jitem.quote})
                    })
                })
                if(!bstop) return this.$message.warning(this.$t('toolsProfit.Quote') + this.$t('emptyWarningText') )
                billApi.calculate({...this.form, chargeItems: arr}).then(res=>{
                    this.tableData.forEach(item => {
                        item.chargeItems.forEach(jitem=>{
                            for (const [key, value] of Object.entries(res.data.quantityMap)) {
                                if(jitem.billCategoryCode == key){
                                    jitem.quantity = value
                                }
                            }
                        })
                    })
                    this.calculateTable = res.data.proftCalculateResps
                })
            }
        })
    },
    isNotEmptyOrZero(value) {
        return value !== null && value !== undefined && value !== "" && value !== false;
    },
    downLoad(){
        let arr = []
        let bstop = true;
        this.tableData.forEach(item=>{
            item.chargeItems.forEach(jitem=>{
                if(!this.isNotEmptyOrZero(jitem.quote)){
                    bstop = false;
                }
                arr.push({ billCategoryCode: jitem.billCategoryCode, quote: jitem.quote})
            })
        })
        if(!bstop) return this.$message.warning(this.$t('toolsProfit.Quote') + this.$t('emptyWarningText') )
        billApi.downloadChargeItems(arr).then(res=>{
            downloadBlob(res, `${this.$t('toolsProfit.ChargeItems')}.xlsx`);
        })
    },
    getClientInfoList() {
        billApi.getClientInfoList().then(res => {
          res.data.forEach(item => {
            item.label = `${item.label} - ${item.value}`;
          });
          this.clientCodeList = res.data;
        });
    },
  }
}
</script>

<style lang="scss" scoped>
.profit{
    &-left{
        width: 530px;
        padding: 0 20px;
        border: 1px solid #ddd;
        border-radius: 10px;
        background: #fff;
    }
    &-right{
        width: calc(100% - 540px);
        padding: 0 20px;
        border: 1px solid #ddd;
        border-radius: 10px;
        background: #fff;
        padding-bottom: 10px;
    }
    &-bottom{
        padding: 0 20px 50px;
        border: 1px solid #ddd;
        border-radius: 10px;
        background: #fff;
        margin-top: 10px;
        min-height: 360px;
    }
}
::v-deep .el-input-group__append {
  background: $main-dark;
  color: #ffffff;
}
::v-deep .el-table__header-wrapper .el-checkbox {
  visibility: hidden;
}
</style>